export const ALREADY_READ_ERROR = 'Este pacote já foi lido';
